export const EXPENSE_STATUS = ["Pendiente", "Programado", "Pagado"] as const;
export type ExpenseStatus = typeof EXPENSE_STATUS[number];
